import { MoneyBox } from '@apply/components';
import { usePropertyRentalTargetLoanRequest } from '../../../../queries/PropertyFields/RentalCoreFields';
import { ApplicationQuestionReviewItem } from '../../../components/ApplicationQuestionReviewItem';
import { formatCurrencyOrUndefined } from '@apply/ui';

export interface TargetLoanRequestRentalProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const TargetLoanRequestRental: React.FC<TargetLoanRequestRentalProps> = ({ propertyGuid, required, isReview = false }) => {
    const label = 'Target Loan Request';
    const [targetLoanRequest, set_targetLoanRequest] = usePropertyRentalTargetLoanRequest(propertyGuid);
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(Number(targetLoanRequest))}
                />
            ) : (
                <MoneyBox
                    id='targetLoanRequest'
                    allowNegative={false}
                    value={targetLoanRequest}
                    onChange={(value) => set_targetLoanRequest(value)}
                    label={label}
                    required={required}
                    displayChange={false}
                    min={100000}
                    max={5000000}
                />
            )}
        </>
    );
};
